module.exports = __webpack_public_path__ + "static/media/droid_sans_mono_regular.typeface.32259ce7.fjson";